import React from 'react';
import ModalTextField from 'components/ModalTextField';
import LogoUploader from 'components/LogoUploader';
import { CompanyDetailsSectionProps } from 'interfaces/components/dataEntryModal/CompanyDetailsSection';
import { companyWebsiteField } from 'utils/constants/fields';

const CompanyDetailsSection = ({
  companyDetailsParentRef,
  companyDetailsRef,
  companyLogoURL,
  onImageUpload,
  fileInputRef,
  handleImageUploadInputClick,
  invalidFileSize,
  setCompanyLogoURL,
  color,
  companyWebsite,
  onColorChange,
  onCompanyWebsiteChange
}: CompanyDetailsSectionProps) => {
  return (
    <div className='w-full' ref={companyDetailsParentRef}>
      <div
        className='w-full flex flex-col items-start gap-4'
        ref={companyDetailsRef}
      >
        <p className='text-[24px] leading-[19.2px] font-light'>
          Company Details
        </p>
        <LogoUploader
          title="Upload Company's Logo"
          companyLogoURL={companyLogoURL}
          onImageUpload={onImageUpload}
          handleImageUploadInputClick={handleImageUploadInputClick}
          setCompanyLogoURL={setCompanyLogoURL}
          fileInputRef={fileInputRef}
          invalidFileSize={invalidFileSize}
        />
        <div className='w-full flex gap-4'>
          <ModalTextField
            label='Brand Color'
            name='brand_color'
            value={color}
            onChange={onColorChange}
            placeholder='Enter brand color'
            isColorSelector
          />
          <ModalTextField
            {...companyWebsiteField}
            value={companyWebsite}
            onChange={onCompanyWebsiteChange}
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyDetailsSection;
